
import { Component } from 'vue-property-decorator';
import VWrapper from '@/components/shared/VWrapper.vue';
import UpsellSyncForm from '@/components/sync/UpsellSyncForm.vue';
import SyncApiService from '@/api/http/SyncApiService';
import Notification from '@/mixins/Notification';
import { mixins } from 'vue-class-component';

@Component({
  components: { UpsellSyncForm, VWrapper },
})
export default class CreateUpsellSync extends mixins(Notification) {
  public $refs!: {
    form: InstanceType<typeof UpsellSyncForm> & { getData: () => any; validate: () => Promise<boolean | boolean[]> };
  };

  public save() {
    this.$refs.form.validate().then(async (res: boolean) => {
      if (res) {
        const api: SyncApiService = new SyncApiService();
        api
          .syncUpsells(this.$refs.form.getData())
          .then(() => {
            this.notifyInfo('sync.notification.running');
          })
          .catch((err: Error) => {
            console.error(err);
            this.notifyInfo('sync.notification.error');
          });
      } else {
        this.notifyError('notification.form');
      }
    });
  }
}
